import { render, staticRenderFns } from "./businessTabbar.vue?vue&type=template&id=35375cf6&scoped=true"
import script from "./businessTabbar.vue?vue&type=script&lang=js"
export * from "./businessTabbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35375cf6",
  null
  
)

export default component.exports